package com.example.monetix

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.CanvasBasedWindow
import app.cash.sqldelight.driver.worker.WebWorkerDriver
import com.example.monetix.db.MonetixDatabase
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.launch
import org.jetbrains.skiko.wasm.onWasmReady
import org.w3c.dom.Worker
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.initialize
import dev.gitlive.firebase.FirebaseOptions
import com.example.monetix.utils.FileExporter
import com.example.monetix.utils.ExportMode
import com.example.monetix.db.TransactionEntity

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    js("Object.defineProperty(Object.prototype, 'tmpdir', { value: function() { return '/tmp'; }, enumerable: false, writable: true, configurable: true });")

    val webFileExporter = object : FileExporter {
        override fun exportAndSharePdf(
            transactions: List<TransactionEntity>,
            title: String,
            totalCents: Long,
            categoryNames: Map<String, String>,
            availableBalanceCents: Long,
            exportMode: ExportMode
        ) {
            println("Esportazione PDF non supportata su Web")
        }
    }

    onWasmReady {
        MainScope().launch {
            try {
                Firebase.initialize(
                    options = FirebaseOptions(
                        apiKey = "AIzaSyBfdvdrKCxEoUhHmSgQdi5TSMPj_leCKec",
                        authDomain = "monetix-60001.firebaseapp.com",
                        projectId = "monetix-60001",
                        storageBucket = "monetix-60001.firebasestorage.app",
                        gcmSenderId = "405332148141",
                        applicationId = "1:405332148141:web:9d57fc5636e87531ac6b24"
                    )
                )
                println("🔥 Firebase KMP Inizializzato con successo!")
            } catch (e: Throwable) {
                println("⚠️ Errore di setup Firebase: ${e.message}")
            }

            try {
                val worker = js("""new Worker(new URL("@cashapp/sqldelight-sqljs-worker/sqljs.worker.js", import.meta.url), { type: "module" })""").unsafeCast<Worker>()
                val driver = WebWorkerDriver(worker)

                MonetixDatabase.Schema.create(driver).await()
                val database = MonetixDatabase(driver)

                println("✅ Database inizializzato con successo!")

                CanvasBasedWindow(title = "Monetix", canvasElementId = "ComposeTarget") {
                    App(
                        database = database,
                        fileExporter = webFileExporter,
                    )
                }
            } catch (e: Throwable) {
                println("🚨 CRASH FATALE DATABASE/WORKER: ${e.message}")
            }
        }
    }
}
